import { ApiConfig } from '../Api_Config/ApiEndpoints';
import { ApiCallGet, ApiCallPost } from '../Api_Config/ApiCall';


interface ApiHeaders {
    'Content-Type': string;
    Authorization?: string;
}

const StockService = {
    getOverview: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, overview } = ApiConfig;
        const url = apiUrl + overview + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },

    getMetrics: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, metrics } = ApiConfig;
        const path = metrics.endsWith('/') ? metrics : `${metrics}/`;
        const url = apiUrl + path + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },

    getMetricsBySymbol: async (symbol: any): Promise<any> => {
        return StockService.getMetrics(symbol);
    },

    getMarketSegmentDetails: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { aiUrl, marketSegmentDetails } = ApiConfig;
        const url = aiUrl + marketSegmentDetails + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getSockSymbols: async (): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, stockSymbols } = ApiConfig;
        const url = apiUrl + stockSymbols;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getSotckSymbolsIR: async (): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, stockSymblosIR } = ApiConfig;
        const url = apiUrl + stockSymblosIR;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getStockSymbolsSearch: async (query: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, stockSymblosSearch } = ApiConfig;
        const url = apiUrl + stockSymblosSearch + `?query=${query}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getBalanceSheetBreakdown: async (symbol: any, period: 'annual' | 'quarter' = 'annual'): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, balanceSheetBreakdown } = ApiConfig;
        const url = `${apiUrl}${balanceSheetBreakdown}?symbol=${symbol}&period=${period}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getBalanceSheetHistory: async (symbol: any, view: any, period: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, balanceSheetHistory } = ApiConfig;
        const url = apiUrl + balanceSheetHistory + `?symbol=${symbol}&period=${period}&viewFormat=${view}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getIncomeStatement: async (symbol: any, period: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, incomeStamentBreakdown } = ApiConfig;
        const url = apiUrl + incomeStamentBreakdown + `?symbol=${symbol}&period=${period}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getIncomeStatementBreakdown: async (symbol: any, period: 'annual' | 'quarter' = 'annual'): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { incomeStatementUrl, incomeStamentBreakdown } = ApiConfig;
        const url = `${incomeStatementUrl}${incomeStamentBreakdown}?symbol=${symbol}&period=${period}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getAnalystForecasts: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, analystForecasts } = ApiConfig;
        const url = apiUrl + analystForecasts + `/${symbol}?projectionType=custom`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getAnalystForecastsWithOut: async (symbol: any, period?: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, analystForecasts } = ApiConfig;
        const url = apiUrl + analystForecasts + `/${symbol}?period=${period}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getRecentEarningsAIReport: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { earningsUrl, getRecentEarningsAIReport } = ApiConfig;
        const url = earningsUrl + getRecentEarningsAIReport + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getIncomeEnhancedHistory: async (symbol: any, period: any = "annual", view: any = "flattened", comparisonType: any = "yoy"): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { incomeStatementUrl, incomeEnhancedHistory } = ApiConfig;
        const url = incomeStatementUrl + incomeEnhancedHistory + `?symbol=${symbol}&period=${period}&view=${view}&comparisonType=${comparisonType}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getRevenueBreakdown: async (symbol: any, period: any = "quarter"): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { incomeStatementUrl, revenueBreakdown } = ApiConfig;
        const url = incomeStatementUrl + revenueBreakdown + `?symbol=${symbol}&period=${period}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getCashflowBreakdown: async (symbol: any, period: any = "quarter"): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { cashflowUrl, cashflowBreakdown } = ApiConfig;
        const url = cashflowUrl + cashflowBreakdown + `?symbol=${symbol}&period=${period}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getCashflowHistory: async (symbol: any, period: any = "annual", viewFormat: any = "flattened"): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { cashflowUrl, cashflowHistory } = ApiConfig;
        const url = cashflowUrl + cashflowHistory + `?symbol=${symbol}&period=${period}&view=${viewFormat}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getMetricsKeys: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, metricKeys } = ApiConfig;
        const url = apiUrl + metricKeys + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getMetricKeysByProvider: async (providerName: string = 'FMP'): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, metricKeys } = ApiConfig;
        const url = `${apiUrl}${metricKeys}?providerName=${providerName}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getMetricsBySymbolsSPY: async (): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, metrics } = ApiConfig;
        const url = apiUrl + metrics + `/spy-qqq-ai-metrics`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getMetricsLifetimeValue: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, lifetimeMetrics } = ApiConfig;
        const url = apiUrl + lifetimeMetrics + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getMetricsValuesTrend: async (symbol: any, data: any, period: any = "annual"): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, metricValuesTrend } = ApiConfig;
        const url = apiUrl + metricValuesTrend + `?symbol=${symbol}&period=${period}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallPost(url, data, headers);
    },
    getChartTimeSeries: async (params: { symbol: string; period: 'annual' | 'quarter'; metrics: string[]; includePrice?: boolean; from?: string; to?: string; }): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, chartTimeSeries } = ApiConfig;
        const url = `${apiUrl}${chartTimeSeries}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallPost(url, params, headers);
    },
    getEarningCalls: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { baseUrl, getEarningCalls } = ApiConfig;
        const url = baseUrl + getEarningCalls + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getSecFiles: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { baseUrl, getSecFiles } = ApiConfig;
        const url = baseUrl + getSecFiles + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getSwotAnalysis: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { aiUrl, swotAnalysis } = ApiConfig;
        const url = aiUrl + swotAnalysis + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getCompanyPerformanceSnapshot: async (symbol: any, period: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { baseUrl, companyPerformanceSnapshot } = ApiConfig;
        const url = `${baseUrl}${companyPerformanceSnapshot}?symbol=${symbol}&period=${period}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getSharePriceSeries: async (symbol: string): Promise<any> => {
        const { baseUrl, sharePriceSeries } = ApiConfig;
        const url = `${baseUrl}${sharePriceSeries}?symbol=${encodeURIComponent(symbol)}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
        };
        return ApiCallGet(url, headers);
    },
    getDashboard: async (): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, stockResearchDashboard } = ApiConfig;
        const url = apiUrl + stockResearchDashboard;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getCategories: async (symbol: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, metricCategories } = ApiConfig;
        const url = apiUrl + metricCategories + `?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getMetricsByCategory: async (symbol: any, key: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, metricsByCategory } = ApiConfig;
        const url = apiUrl + metricsByCategory + `/${key}?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getMetricsBySubCategory: async (symbol: any, key: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, metricsBySubCategory } = ApiConfig;
        const url = apiUrl + metricsBySubCategory + `/${key}?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getNextYearBlendedPriceTarget: async (symbol: string, autoPe: boolean = true): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, priceTargetsNextYearBlended } = ApiConfig;
        const url = `${apiUrl}${priceTargetsNextYearBlended}?symbol=${encodeURIComponent(symbol)}&autoPe=${autoPe}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getNextYearPriceTarget: async (symbol: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, priceTargetsNextYear } = ApiConfig;
        const url = `${apiUrl}${priceTargetsNextYear}?symbol=${encodeURIComponent(symbol)}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getAnalystRatingsHistory: async (symbol: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, analystRatingsHistory } = ApiConfig;
        const url = `${apiUrl}${analystRatingsHistory}?symbol=${symbol}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getAnalystEstimates: async (symbol: string, period: 'annual' | 'quarter' = 'annual'): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, analystEstimates } = ApiConfig;
        const url = `${apiUrl}${analystEstimates}?symbol=${symbol}&period=${period}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getAnalystDashboard: async (symbol: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, analystDashboard } = ApiConfig;
        const url = `${apiUrl}${analystDashboard}?symbol=${encodeURIComponent(symbol)}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        try {
            return await ApiCallGet(url, headers);
        } catch (err: any) {
            if (err?.status === 404) {
                return await StockService.getAnalystPriceTargetTable(symbol);
            }
            throw err;
        }
    },
    getAnalystPriceTargetTable: async (symbol: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, analystPriceTargetTable } = ApiConfig;
        const url = `${apiUrl}${analystPriceTargetTable}?symbol=${encodeURIComponent(symbol)}`;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getProducts: async (): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { billingUrl, products } = ApiConfig;
        const url = billingUrl + products;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallGet(url, headers);
    },
    getCheckout: async (params: any): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { billingUrl, checkout } = ApiConfig;
        const url = billingUrl + checkout;
        const headers: ApiHeaders = {
            'Content-Type': 'application/json',
            Authorization: token,
        };
        return ApiCallPost(url, params, headers);
    },
    getMarketMovers: async (type: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { baseUrl } = ApiConfig;
        let endpoint = '';
        if (type === 'gainers') endpoint = 'market/leaders/gainers';
        else if (type === 'losers') endpoint = 'market/leaders/losers';
        else if (type === 'active') endpoint = 'market/leaders/most-active';
        const url = `${baseUrl}${endpoint}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getMarketPeSnapshot: async (type: 'sector' | 'industry', date: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { baseUrl } = ApiConfig;
        const url = `${baseUrl}market/pe/${type}/snapshot?date=${date}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getTopGainers: async (): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, topGainers } = ApiConfig;
        const url = apiUrl + topGainers;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getTopLosers: async (): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, topLosers } = ApiConfig;
        const url = apiUrl + topLosers;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    subscribeNewsletter: async (email: string): Promise<any> => {
        const { baseUrl, newsletter } = ApiConfig;
        const url = baseUrl + newsletter;
        const headers: ApiHeaders = { 'Content-Type': 'application/json' };
        return ApiCallPost(url, { email }, headers);
    },
    getSuperInvestorsByRank: async (): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, superInvestorsByRank } = ApiConfig;
        const url = apiUrl + superInvestorsByRank;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getInstitutionalOwnershipHistory: async (symbol: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, institutionalOwnershipHistory } = ApiConfig;
        const url = `${apiUrl}${institutionalOwnershipHistory}?symbol=${encodeURIComponent(symbol)}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getInstitutionalTopBuyers: async (symbol: string, period?: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, institutionalTopBuyers } = ApiConfig;
        let url = `${apiUrl}${institutionalTopBuyers}?symbol=${encodeURIComponent(symbol)}`;
        if (period) url += `&period=${encodeURIComponent(period)}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getInstitutionalTopSellers: async (symbol: string, period?: string): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, institutionalTopSellers } = ApiConfig;
        let url = `${apiUrl}${institutionalTopSellers}?symbol=${encodeURIComponent(symbol)}`;
        if (period) url += `&period=${encodeURIComponent(period)}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getInstitutionalHoldings: async (symbol: string, period?: string, page: number = 0, size: number = 20, search: string = ''): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, institutionalHoldings } = ApiConfig;
        let url = `${apiUrl}${institutionalHoldings}?symbol=${encodeURIComponent(symbol)}&page=${page}&size=${size}`;
        if (period) url += `&period=${encodeURIComponent(period)}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getAumLeaderboard: async (params: { year: number; quarter: number; page?: number; size?: number; sortBy?: string; direction?: 'asc' | 'desc'; query?: string; }): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, aumLeaderboard } = ApiConfig;
        const { year, quarter, page = 0, size = 25, sortBy = 'holdings', direction = 'desc', query } = params;
        const qVal = query?.trim();
        const qParam = qVal && qVal !== ''
            ? `&q=${encodeURIComponent(qVal)}&query=${encodeURIComponent(qVal)}&name=${encodeURIComponent(qVal)}`
            : '';
        const url = `${apiUrl}${aumLeaderboard}?year=${year}&quarter=${quarter}&page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&direction=${direction}${qParam}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getTopByReducedPositions: async (limit: number = 50): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, topByReducedPositions } = ApiConfig;
        const url = `${apiUrl}${topByReducedPositions}?limit=${limit}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getTopByPutOptions: async (limit: number = 50): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, topByPutOptions } = ApiConfig;
        const url = `${apiUrl}${topByPutOptions}?limit=${limit}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getTopByNewPositions: async (limit: number = 50): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, topByNewPositions } = ApiConfig;
        const url = `${apiUrl}${topByNewPositions}?limit=${limit}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getTopByIncreasedPositions: async (limit: number = 50): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, topByIncreasedPositions } = ApiConfig;
        const url = `${apiUrl}${topByIncreasedPositions}?limit=${limit}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getTopByFundsHolding: async (limit: number = 50): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, topByFundsHolding } = ApiConfig;
        const url = `${apiUrl}${topByFundsHolding}?limit=${limit}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getTopByClosedPositions: async (limit: number = 50): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, topByClosedPositions } = ApiConfig;
        const url = `${apiUrl}${topByClosedPositions}?limit=${limit}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
    getTopByCallOptions: async (limit: number = 50): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, topByCallOptions } = ApiConfig;
        const url = `${apiUrl}${topByCallOptions}?limit=${limit}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },

    // Institution Portfolio Endpoints (CIK-based)
    getInstitutionPortfolioWithChanges: async (cik: string, params?: { period?: string; year?: number; quarter?: number; page?: number; size?: number; search?: string; positionType?: string }): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, institutionPortfolioWithChanges } = ApiConfig;
        let url = `${apiUrl}${institutionPortfolioWithChanges}?cik=${encodeURIComponent(cik)}`;
        if (params?.period) url += `&period=${encodeURIComponent(params.period)}`;
        if (params?.year) url += `&year=${params.year}`;
        if (params?.quarter) url += `&quarter=${params.quarter}`;
        if (params?.page !== undefined) url += `&page=${params.page}`;
        if (params?.size) url += `&size=${params.size}`;
        if (params?.search) url += `&search=${encodeURIComponent(params.search)}`;
        if (params?.positionType) url += `&positionType=${encodeURIComponent(params.positionType)}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },

    getInstitutionPortfolioSummary: async (cik: string, params?: { period?: string; year?: number; quarter?: number }): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, institutionPortfolioSummary } = ApiConfig;
        let url = `${apiUrl}${institutionPortfolioSummary}?cik=${encodeURIComponent(cik)}`;
        if (params?.period) url += `&period=${encodeURIComponent(params.period)}`;
        if (params?.year) url += `&year=${params.year}`;
        if (params?.quarter) url += `&quarter=${params.quarter}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },

    getInstitutionTopBuys: async (cik: string, params?: { period?: string; year?: number; quarter?: number; limit?: number }): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, institutionTopBuys } = ApiConfig;
        let url = `${apiUrl}${institutionTopBuys}?cik=${encodeURIComponent(cik)}`;
        if (params?.period) url += `&period=${encodeURIComponent(params.period)}`;
        if (params?.year) url += `&year=${params.year}`;
        if (params?.quarter) url += `&quarter=${params.quarter}`;
        if (params?.limit) url += `&limit=${params.limit}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },

    getInstitutionTopSells: async (cik: string, params?: { period?: string; year?: number; quarter?: number; limit?: number }): Promise<any> => {
        const token = sessionStorage.getItem('STOCK_AUTH_TOKEN') ?? '';
        const { apiUrl, institutionTopSells } = ApiConfig;
        let url = `${apiUrl}${institutionTopSells}?cik=${encodeURIComponent(cik)}`;
        if (params?.period) url += `&period=${encodeURIComponent(params.period)}`;
        if (params?.year) url += `&year=${params.year}`;
        if (params?.quarter) url += `&quarter=${params.quarter}`;
        if (params?.limit) url += `&limit=${params.limit}`;
        const headers: ApiHeaders = { 'Content-Type': 'application/json', Authorization: token };
        return ApiCallGet(url, headers);
    },
};
export default StockService;